var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotifyGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #747474;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256,256-114.6,256-256S397.4,0,256,0ZM373.4,369.2c-4.6,7.6-14.4,9.9-21.9,5.3-60.1-36.7-135.8-45-224.9-24.7-8.6,2-17.2-3.4-19.1-12-2-8.6,3.4-17.2,12-19.1,97.5-22.3,181.2-12.7,248.6,28.5,7.5,4.7,9.9,14.5,5.3,22ZM404.7,299.5c-5.8,9.4-18.1,12.3-27.5,6.6-68.8-42.3-173.7-54.5-255.1-29.8-10.5,3.2-21.7-2.8-24.9-13.3-3.2-10.6,2.8-21.7,13.3-24.9,93-28.2,208.6-14.5,287.6,34,9.5,5.8,12.4,18.1,6.6,27.4ZM407.4,226.9c-82.5-49-218.6-53.5-297.4-29.6-12.7,3.8-26-3.3-29.9-16-3.8-12.7,3.3-26,16-29.9,90.4-27.5,240.7-22.1,335.7,34.2,11.4,6.8,15.1,21.4,8.4,32.8-6.7,11.6-21.4,15.3-32.8,8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyGris);
export default __webpack_public_path__ + "static/media/spotify-gris.c1da773e1a9184a0efb40411445c6b69.svg";
export { ForwardRef as ReactComponent };